import React from 'react';

import { TooltipButton } from '@/components/molecules/tooltip-button';
import { useHandleUpdateSettings } from '@/features/equipment-browser/action-components/use-handle-update-settings';
import { EnhancedSetting } from '@/features/equipment-browser/subscriptions/use-get-settings-values';
import { PRIVILEGES } from '@/hooks/access/access-table';
import { useActionPermission } from '@/hooks/use-action-permission';

interface SettingFieldButtonProps {
  setting: EnhancedSetting;
}

/**
 * Button display component for action-type settings.
 * Triggers an action when clicked.
 */
export const SettingFieldButton = ({ setting }: SettingFieldButtonProps): React.ReactElement => {
  const { isDisabled: disabledByPermissions, tooltipText } = useActionPermission({
    privilege: PRIVILEGES.writeCommands,
  });
  const { handleUpdateSettings, isPending } = useHandleUpdateSettings();

  const updateSettingAction = async () => {
    if (isPending) return;

    try {
      await handleUpdateSettings([
        {
          id: setting.ref.id,
          valueKind: setting.ref.valueKind,
          booleanValue: true,
        },
      ]);
    } catch (error) {
      console.error('Failed to update setting:', error);
    }
  };

  return (
    <TooltipButton
      onClick={updateSettingAction}
      disabled={isPending || disabledByPermissions}
      className="w-full btn btn-tier2"
      tooltipContent={disabledByPermissions ? tooltipText : undefined}
      wrapperClassName="w-full"
    >
      {setting.label}
    </TooltipButton>
  );
};
